<template>
  <div class="createInstitution">
    <!-- 步骤条 -->
    <el-steps
      :active="step"
      class="createSteps"
      process-status="process"
      finish-status="success"
    >
      <el-step title="填写基础信息" description="创建商户"></el-step>
      <el-step title="商户业务配置" description="输入配置信息"></el-step>
      <el-step title="完成创建" description="创建成功"></el-step>
    </el-steps>
    <!-- 步骤一 -->
    <div class="step" v-if="step === 0">
      <el-form
        :model="formData1"
        :rules="rules1"
        ref="ruleForm1"
        label-width="100px"
      >
        <el-form-item label="商户名称" prop="name">
          <el-input
            v-model.trim="formData1.name"
            style="width:20vw"
            placeholder="请输入商户名称"
          ></el-input>
        </el-form-item>
        <el-form-item label="商户编码" prop="code">
          <el-input
            v-model.trim="formData1.code"
            style="width:20vw"
            placeholder="请输入商户编码"
          ></el-input>
        </el-form-item>
        <el-form-item label="商户类型" prop="type">
          <el-select
            v-model="formData1.type"
            style="width:20vw"
            placeholder="请选择商户类型"
          >
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <el-button class="nextStep" type="primary" size="small" @click="nextStep"
        >下一步</el-button
      >
    </div>
    <!-- 步骤二 -->
    <div class="step" v-if="step === 1">
      <el-form
        :model="formData2"
        :rules="rules2"
        ref="ruleForm2"
        label-width="100px"
      >
        <el-form-item label="对接模式" prop="mode">
          <el-checkbox-group v-model="formData2.mode">
            <el-checkbox label="云云对接" name="mode"></el-checkbox>
            <el-checkbox label="设备对接" name="mode"></el-checkbox>
            <el-checkbox label="其他" name="mode"></el-checkbox>
          </el-checkbox-group>
        </el-form-item>
        <el-form-item label="负责人" prop="head">
          <el-input
            v-model="formData2.head"
            style="width:20vw"
            placeholder="请输入负责人"
          ></el-input>
        </el-form-item>
        <el-form-item label="联系电话" prop="phone">
          <el-input
            v-model="formData2.phone"
            style="width:20vw"
            placeholder="请输入联系电话"
          >
          </el-input>
        </el-form-item>
        <el-form-item label="邮箱" prop="email">
          <el-input
            v-model="formData2.email"
            style="width:20vw"
            placeholder="请输入邮箱"
          >
          </el-input>
        </el-form-item>
      </el-form>
      <el-button class="preStep" type="info" size="small" @click="preStep"
        >上一步</el-button
      >
      <el-button type="primary" size="small" @click="submit">提交</el-button>
    </div>
    <!-- 步骤三 -->
    <div class="step" v-if="step === 2">
      <div class="successImg">
        <img class="createdImg" :src="createdImg" alt="" srcset="" />
      </div>
      <div style="text-align:center">创建成功</div>
      <div style="text-align:center;color:#86909C">表单创建成功</div>
      <div class="createdButtons">
        <el-button type="info" size="small" @click="goDetail"
          >查看商户</el-button
        >
        <el-button type="primary" size="small" @click="createAgain"
          >再次创建</el-button
        >
      </div>
    </div>
    <div class="institutionDiscreption" v-if="step === 2">
      <div class="discrepTitle">商户说明</div>
      <div class="discrepContent">
        商户创建时系统生成平台唯一token秘钥
        [<span>*********</span>],该秘钥为平台对接安全校验码，注意请勿泄露。
      </div>
    </div>
  </div>
</template>

<script>
import { businessAdd } from "@/api/institutionApi";
export default {
  data() {
    return {
      createdImg: require("@/assets/images/check-circle-fill@2x.png"),
      // 控制步骤显示
      step: 0,
      // 步骤一数据手机
      formData1: {
        name: "",
        code: "",
        type: ""
      },
      // 步骤二数据收集
      formData2: {
        mode: [],
        head: "",
        phone: "",
        email: ""
      },
      // 商户类型下拉选项
      options: [],
      // 步骤一表单校验规则
      rules1: {
        name: [
          { required: true, message: "请输入商户名称", trigger: "blur" },
          {
            pattern: /^[\S]{0,30}$/,
            message: "请输入30位以内的字符",
            trigger: "blur"
          }
        ],
        code: [
          { required: true, message: "请输入商户编码", trigger: "blur" },
          {
            pattern: /^[a-zA-Z0-9!@#$%^&*()_+-/~=?]{0,20}$/,
            message: "仅支持输入20位以内的字母或数字或特殊字符",
            trigger: "blur"
          }
        ],
        type: [{ required: true, message: "请选择商户类型", trigger: "blur" }]
      },
      // 步骤二表单校验规则
      rules2: {
        mode: [
          {
            type: "array",
            required: true,
            message: "请至少选择一个对接模式",
            trigger: "change"
          }
        ]
        // head: [
        //   { required: true, message: '请输入负责人', trigger: 'blur' }
        // ],
        // phone: [
        //   { required: true, message: '请输入联系电话', trigger: 'blur' }
        // ],
        // email: [
        //   { required: true, message: '请输入邮箱', trigger: 'blur' }
        // ]
      },
      // 创建成功的id
      id: ""
    };
  },
  created() {
    // 获取商户类型的选项列表
    this.options = JSON.parse(localStorage.getItem("institutionType"));
  },
  methods: {
    // 上一步按钮
    preStep() {
      this.step = 0;
    },
    // 下一步按钮
    nextStep() {
      this.$refs.ruleForm1.validate(valid => {
        if (valid) {
          this.step = 1;
        }
      });
    },
    // 提交按钮
    submit() {
      this.$refs.ruleForm2.validate(async valid => {
        if (valid) {
          // 对接模式传参修改
          const mapping = {
            云云对接: 1,
            设备对接: 2,
            其他: 3
          };
          const mode = this.formData2.mode.map(item => mapping[item]);
          const { data } = await businessAdd({
            docking_mode: mode,
            type: this.formData1.type,
            code: this.formData1.code,
            name: this.formData1.name,
            head: this.formData2.head,
            mobile: this.formData2.phone,
            email: this.formData2.email
          });
          if (data.code === 1000) {
            this.step = 2;
            this.id = data.data.data.id;
            // this.platformKey = data.data.data.platformKey
          } else {
            this.$message.error(data.msg);
          }
        }
      });
    },
    // 跳转详情页
    goDetail() {
      this.$router.push({
        path: "/institutionDetail",
        query: { id: this.id }
      });
    },
    // 再次创建按钮
    createAgain() {
      (this.formData1 = {
        name: "",
        code: "",
        type: ""
      }),
        (this.formData2 = {
          mode: [],
          head: "",
          phone: "",
          email: ""
        }),
        (this.step = 0);
    }
  }
};
</script>

<style lang="less" scoped>
.createInstitution {
  box-sizing: border-box;
  height: 100%;
  padding-top: 100px;
  background-color: #fff;
}
.createSteps {
  width: 40vw;
  margin: 0 auto;
}
.step {
  width: 30vw;
  margin: 0 auto;
  padding-top: 76px;
}
.nextStep,
.preStep {
  margin-left: 100px;
  /* margin: 0 auto; */
}
.successImg {
  padding: 100px 0 20px;
  text-align: center;
  .createdImg {
    width: 48px;
    height: 48px;
  }
}
.createdButtons {
  text-align: center;
  padding-top: 20px;
}
.institutionDiscreption {
  width: 50vw;
  margin: 100px auto;
  background: #f7f8fa;
  padding: 20px;
}
.discrepTitle {
  padding-bottom: 16px;
}
.discrepContent {
  padding-bottom: 16px;
}
</style>
